<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<p class="calibre3"><span class="x-ebookmaker-pageno" id="pgepubid00115" title="[136]"><a id="Page_136"></a></span></p>
<h2 id="A_SUCCESSFUL_ESCAPE">A SUCCESSFUL ESCAPE.</h2>
</div>
<div class="blockquot">
<p class="calibre3">JUMP OFF THE CARS NEAR SAVANNAH—FIND FRIENDLY NEGROES—TRAVEL
BY NIGHT AND REST BY DAY—GOOD TIMES WITH MANY
ADVENTURES—A MORNING BATH—ALMOST RUN INTO REBEL PICKETS,
ETC., ETC.</p>
</div>
<p class="calibre3"><span class="smcap">In the Woods</span>, Dec 13.—How does that sound for a location
to date from? Yesterday long toward night our train started from
its abiding place and rolled slowly toward its destination, wherever
that might be. When near Savannah, not more than a mile
this side, David Buck jumped off the cars and rolled down the bank.
I jumped next and Eli Buck came right after me. Hastily got up
and joined one another, and hurried off in an easterly direction
through the wet, swampy country. A number of shots were fired
at us, but we were surprised and glad to find that none hit us,
although my cap was knocked off by a bullet hitting the fore-piece.
Eli Buck was also singed by a bullet. It seemed as if a dozen
shots were fired. Train did not stop, and we ran until tired out.
Knew that we were within a line of forts which encircle Savannah,
going all the way around it and only twenty rods or so apart. It
was dark when we jumped off, and we soon came in the vicinity of
a school house in which was being held a negro prayer meeting.
We peeked in at the windows, but dared not stop so near our
jumping off place. Worked around until we were near the railroad
again and guided by the track going south—the same way we<span class="x-ebookmaker-pageno" title="[137]"><a id="Page_137"></a></span>
had come. It was very dark. Dave Buck went ahead, Eli next and
myself last, going Indian file and very slow. All at once Dave
stopped and whispered to us to keep still, which you may be sure
we did. Had come within ten feet of a person who was going
directly in the opposite direction and also stopped, at the same
time we did. Dave Buck says: “Who comes there?” A negro
woman says “it’s me,” and he walked up close to her and asked
where she was going. She says: “Oh! I knows you; you are
Yankees and has jumped off de cars.” By this time we had come
up even with Dave and the woman. Owned up to her that such
was the case. She said we were her friends, and would not tell of
us. Also said that not twenty rods ahead there was a rebel picket,
and we were going right into them. I think if I ever wanted to
kiss a woman, it was that poor, black, negro wench. She told us
to go about thirty rods away and near an old shed, and she would
send us her brother; he would know what to do. We went to the
place designated and waited there an hour, and then we saw two
dusky forms coming through the darkness, and between them a
wooden tray of food consisting of boiled turnips, corn bread and
smoked bacon. We lay there behind that old shed and ate and
talked, and talked and ate, for a full hour more. The negro,
“Major,” said he was working on the forts, putting them in order
to oppose the coming of the Yankees, and he thought he could get
us through the line before morning to a safe hiding place. If we
all shook hands once we did fifty times, all around. The negroes
were fairly jubilant at being able to help genuine Yankees. Were
very smart colored people, knowing more than the ordinary run of
their race. Major said that in all the forts was a reserve picket
force, and between the forts the picket. He said pretty well south
was a dilapidated fort which had not as yet been repaired any, and
that was the one to go through or near, as he did not think there
was any picket there. “Bress de Lord, for yo’ safety,” says the
good woman. We ate all they brought us, and then started under
the guidance of Major at somewhere near midnight. Walked slow
and by a roundabout way to get to the fort and was a long time
about it, going through a large turnip patch and over and through
hedges. Major’s own safety as much as ours depended upon the
trip. Finally came near the fort and discovered there were rebels
inside and a picket off but a few rods. Major left us and crawled
slowly ahead to reconnoitre; returned in a few minutes and told us
to follow. We all climbed over the side of the fort, which was very<span class="x-ebookmaker-pageno" title="[138]"><a id="Page_138"></a></span>
much out of repair. The reserve picket was asleep around a fire
which had nearly gone out. Major piloted us through the fort,
actually stepping over the sleeping rebels. After getting on the
outside there was a wide ditch which we went through. Ditch
was partially full of water. We then went way round near the railroad
again, and started south, guided by the darky, who hurried us
along at a rapid gait. By near daylight we were five or six miles
from Savannah, and then stopped for consultation and rest. Finally
went a mile further, where we are now laying low in a swamp,
pretty well tired out and muddy beyond recognition. Major left us
at daylight, saying he would find us a guide before night who
would show us still further. He had to go back and work on the
forts. And so I am again loose, a free man, with the same old feeling
I had when in the woods before. We got out of a thick settled
country safely, and again await developments. Heard drums and
bugles playing reveille this morning in many directions, and “We
are all surrounded.” David Buck is very confident of getting away
to our lines. Eli thinks it is so if Dave says so, and I don’t know,
or care so very much. The main point with me is to stay out in
the woods as long as I can. My old legs have had a hard time of it
since last night and ache, and are very lame. It’s another beautiful
and cold day, this 13th of December. Biting frost nights, but
warmer in the day time. Our plan is to work our way to the Ogechee
River, and wait for the Stars and Stripes to come to us. Major
said Sherman was marching right toward us all the time, driving
the rebel army with no trouble at all. Told us to keep our ears
open and we would hear cannon one of these days, possibly within
a week. The excitement of the last twenty-four hours has worn
me out, and I couldn’t travel to-day if it was necessary. Have a
plenty to eat, and for a wonder I ain’t hungry for anything except
things we haven’t got. Dave is happy as an oyster, and wants to
yell. Where they are so confident I am satisfied all will be well.
As soon as it comes night we are going up to some negro huts less
than a mile off, where we hope and expect that Major has posted
the inmates in regard to us. The railroad is only a short distance
off, and the river only three or four miles. As near as we know,
are about twenty miles from the Atlantic coast. Tell the boys it
may be necessary for me to stay here for two or three days to get
recruited up, but they think three or four miles to-night will do me
good. Don’t like to burden them and shall try it.</p>
<p class="calibre3"><span class="x-ebookmaker-pageno" id="pgepubid00116" title="[139]"><a id="Page_139"></a></span><br/>
<span class="x-ebookmaker-pageno" id="pgepubid00117" title="[140]"><a id="Page_140"></a></span></p>
<div class="calibre illowe20 figure" id="i_139">
<img alt="Portrait" class="calibre6" id="id-7826390651088535840" src="Images/img0007.jpg"/>
<div class="caption figcaption">David Buck.</div>
</div>
<p class="calibre3"><span class="x-ebookmaker-pageno" id="pgepubid00118" title="[141]"><a id="Page_141"></a></span></p>
<p class="calibre3">Dec. 14.—We are now three miles from yesterday’s resting place,
and near the Miller plantation. Soon as dark last night we went
to the negro huts and found them expecting us. Had a jubilee.
No whites near, but all away. The Buck boys passed near here
before when out in the woods, and knew of many darkys who
befriended them. Had a surfeit of food. Stayed at the huts until
after midnight, and then a woman brought us to this place. To-night
we go to Jocko’s hut, across the river. A darky will row us
across the Little Ogechee to Jocco’s hut, and then he will take us in
tow. It is a rice country about here, with canals running every
way. Negroes all tickled to death because Yankees coming. I am
feeling better than yesterday, but difficult to travel. Tell the boys
they had better leave me with the friendly blacks and go ahead to
our lines, but they won’t. Plenty to eat and milk to drink, which
is just what I want. The whites now are all away from their homes
and most of the negroes. Imagine we can hear the booming of
cannon, but guess we are mistaken. Dave is very entertaining and
good company. Don’t get tired of him and his talk. Both of them
are in rebel dress throughout, and can talk and act just like rebels.
Know the commanders of different rebel regiments. They say that
when out before they on different occasions mixed with the Southern
army, without detection. Said they didn’t wonder the widow
woman knew I was a Yankee. Ain’t up to that kind of thing.</p>
<p class="calibre3">Dec. 15.—Jocko’s hut was not across the river as I supposed and
wrote yesterday, but on the same side we were on. At about ten
o’clock last night we went to his abiding place as directed and
knocked. After a long time an old black head was stuck out of
the window with a nightcap on. The owner of the head didn’t
know Jocko or anything about him; was short and crusty; said:
“Go way from dar!” Kept talking to him and he scolding at being
disturbed. Said he had rheumatics and couldn’t get out to let
us in. After a long time opened the door and we set down on the
door step. Told him we were yankees and wanted help. Was the
funniest darky we have met yet. Would give something for his
picture as he was framed in his window in the moonlight talking
to us, with the picturesque surroundings, and us yankees trying to
win him over to aid us. Finally owned up that he was Jocko, but
said he couldn’t row us across the river. He was lame and could
not walk, had no boat, and if he had the river was so swift he
couldn’t get us across, and if it wasn’t swift, the rebels would catch
him at it and hang him. Talked a long time and with much teasing.
By degrees his scruples gave way, one at a time. Didn’t<span class="x-ebookmaker-pageno" id="pgepubid00119" title="[142]"><a id="Page_142"></a></span>
know but he might row us across if he only had a boat, and finally
didn’t know but he could find a boat. To get thus far into his
good graces took at least three hours. Went looking around and
found an old scow, fixed up some old oars, and we got in; before
doing so however, he had warmed up enough to give us some boiled
sweet potatoes and cold baked fish. Rowed us way down the river
and landed us on the noted Miller plantation and a mile in rear of
the negro houses. Jocko, after we forced our acquaintance on him
with all kind of argument, proved to be a smart able-bodied old
negro, but awful afraid of being caught helping runaways. Would
give something for his picture as he appeared to us looking out of
his cabin window. Just an old fashioned, genuine negro, and so
black that charcoal would make a white mark on him. Took us
probably three miles from his hut, two miles of water and one of
land, and then started back home after shaking us a dozen times
by the hand, and “God blessing us.” Said “Ole Massa Miller’s niggers
all Union niggers,” and to go up to the huts in broad daylight
and they would help us. No whites at home on the plantation.
We arrived where Jocko left us an hour or so before daylight, and
lay down to sleep until light. I woke up after a while feeling wet,
and found the tide had risen and we were surrounded with water;
woke up the boys and scrambled out of that in a hurry, going
through two feet of water in some places. The spot where we had
laid down was a higher piece of ground than that adjoining. Got
on to dry land and proceeded to get dry. At about ten o’clock
Dave went up to the negro huts and made himself known, which
was hard work. The negroes are all afraid that we are rebels and
trying to get them into a scrape, but after we once get them
thoroughly satisfied that we are genuine Yanks they are all right,
and will do anything for us. The negroes have shown us the big
house, there being no whites around, they having left to escape the
coming Yankee army. We went up into the cupola and looked
way off on the ocean, and saw our own noble gunboats. What
would we give to be aboard of them? Their close proximity makes
us discuss the feasibility of going down the river and out to them,
but the negroes say there are chain boats across the river farther
down, and picketed. Still it makes us anxious, our being so near,
and we have decided to go down the river to-night in a boat and
see if we can’t reach them. It is now the middle of the afternoon
and we lay off from the huts eighty rods, and the negroes are about
to bring us some dinner. During the night we traveled over oyster<span class="x-ebookmaker-pageno" title="[143]"><a id="Page_143"></a></span>
beds by the acre, artificial ones, and they cut our feet. Negroes
say there are two other runaways hid a mile off and they are going
to bring them to our abiding place. <span class="smcap">Later.</span>—Negroes have just
fed us with corn bread and a kind of fish about the size of sardines,
boiled by the kettle full, and they are nice. Fully as good as sardines.
Think I know now where nearly all the imported sardines
come from. Negroes catch them by the thousand, in nets, put
them in kettles, and cook them a few minutes, when they are ready
to eat. Scoop them out of the creeks. The two other runaways
are here with us. They are out of the 3d Ohio Cavalry. Have
been out in the woods for two weeks. Escaped from Blackshear
and traveled this far. I used to know one of them in Savannah.
We do not take to them at all, as they are not of our kind. Shall
separate to-night, they going their way and we going ours. Have
secured a dug-out boat to go down the Ogechee River with to-night.
The negroes tell us of a Mr. Kimball, a white man, living up the
country fifteen miles, who is a Union man, and helps runaways, or
any one of Union proclivities. He lays up the river, and our gunboats
lay down the river. Both have wonderful charms for us, and
shall decide before night which route to take. Are on rice plantation,
and a valuable one. Before the “wah” there were over fifteen
hundred negroes on this place. Cotton is also part of the production.
Have decided to go down the river and try to reach our gunboats.
It’s a very hazardous undertaking, and I have my doubts
as to its successful termination.</p>
<p class="calibre3">Dec. 16.—Another adventure, and a red hot one. Started down
the river in our dug-out boat somewhere near midnight. Ran down
all right for an hour, frequently seeing rebel pickets and camp
fires. Saw we were going right into the lion’s mouth, as the farther
down the more rebels. All at once our boat gave a lurch and
landed in a tree top which was sticking out of the water, and there
we were, swaying around in the cold water in the middle or near
the middle of the Ogechee. Dave went ashore and to a negro hut,
woke up the inmates, and narrated our troubles. A negro got up,
and with another boat came to the rescue. Were about froze with
the cold and wet. Said not more than a mile farther down we
would have run right into a chain boat, with pickets posted on it.
It really seems as if a Divine providence were guiding us. After
getting a breakfast of good things started off toward the Big Ogechee
River, and have traveled three or four miles. Are now<span class="x-ebookmaker-pageno" id="pgepubid00120" title="[144]"><a id="Page_144"></a></span>
encamped, or rather laying down, on a little hillock waiting for
evening, to get out of this vicinity which is a dangerous one. In
our river escapade lost many of our things, but still hang to my
coverlid and diary. There are three or four houses in view, and
principally white residences, those of the poor white trash order,
and they are the very ones we must avoid. Have caught cold and
am fearfully out of traveling condition, but must go it now. A
mistake in coming down the river. Am resting up, preparatory to
traveling all night up the country. No chance of getting out by
the coast. Have enough food to last all day and night, and that is
a good deal. Can’t carry more than a day’s supply. Have now
been out in the woods, this is the fourth day, and every day has
been fresh adventures thick and fast. If I could only travel like
my comrades, would get along. Bucks praise me up and encourage
me to work away, and I do. For breakfast had more of those
imported sardines. Storm brewing of some sort and quite chilly.
Saw rebel infantry marching along the highway not more than
eighty rods off. Hugged the ground very close. Dogs came very
near us, and if they had seen us would have attracted the rebels’
attention. Am writing with a pencil less than an inch long. Shall
print this diary and make my everlasting fortune, and when wealthy
will visit this country and make every negro who has helped
us millionaires. Could not move from here half a mile by daylight
without being seen, and as a consequence we are feeling very sore
on the situation. Don’t know but I shall be so lame to-night that I
cannot walk at all, and then the boys must leave me and go ahead
for themselves. However, they say I am worth a hundred dead
men yet, and will prod me along like a tired ox. Dave goes now
bareheaded, or not quite so bad as that, as he has a handkerchief
tied over his head. The programme now is to go as straight to Mr.
Kimball’s as we can. He is probably twenty miles away; is a white
Union man I spoke of a day or so ago in this same diary. Will
stick to him like a brother. Can hear wagons go along the road
toward Savannah, which is only thirteen or fourteen miles away.
<span class="smcap">Later.</span>—Most dark enough to travel and I have straightened up
and am taking an inventory of myself. Find I can walk with the
greatest difficulty. The boys argue that after I get warmed up I
will go like a top, and we will see.</p>
<p class="calibre3">Dec. 17.—And another day of vicissitudes. We traveled last
night about four miles, piloted by a young negro. It was a terrible
walk to me; slow and painful. Were fed, and have food for to-day.<span class="x-ebookmaker-pageno" id="pgepubid00121" title="[145]"><a id="Page_145"></a></span>
Are now about three miles from a canal which we must cross before
another morning. Negroes say “Sherman most here” and “Bress de
Lord!” Mr. Kimball lives nine miles away and we must reach him
some way, but it seems an impossibility for me to go so far. Are
now in a high and fine country, but too open for us. Have to lay
down all day in the bushes. David is a thorough scout. Goes
crawling around on his hands and knees taking in his bearings.
Troops are encamped on the main road. Every cross road has its
pickets, and it is slow business to escape running into them. Eli S.
Buck has a sore throat and is hoarse. Pretty good jaunt for him,
tough as he is. Shall have no guide to-night, as Dave thinks he can
engineer us all right in the right direction. Some thinks he will
leave us both and reach Kimball’s to-night, and then come back and
see us through. Guess I will be on hand to go along however.</p>
<p class="calibre3">Dec. 18.—Six days of freedom and what a sight of hardship,
sweetened by kind treatment and the satisfaction of being out from
under guard. We traveled last night some four miles and now are
in a very precarious position. When almost daylight we came to the
canal, and found cavalry pickets all along the tow-path; walked
along until we came to a lock. A cavalryman was riding his horse
up and down by the lock. At the lock there was a smouldering fire.
It was absolutely necessary that we get across before daylight. As
the mounted picket turned his horse’s head to go from us, Dave slid
across the tow-path and went across the timbers which formed the
lock, and by the time the picket turned around to come back Dave
was hid on the opposite shore. At the next trip of the rebel Eli
went the same as Dave. The third one to go was myself, and I expected
to get caught, sure. Could not go as quiet as the rest,
and was slower. Thought the picket saw me when half way across
but kept right on going, and for a wonder made it all right. Was
thoroughly scared for the first time since jumping off the train. Am
very nervous. All shook hands when the picket turned about to go
back the fourth time. Getting light in the east and we must move
on, as the country is very open. Dare not travel over half a mile,
and here we are hid almost in a woman’s door yard, not over thirty
rods from her very door. Are in some evergreen bushes and shrubs.
It’s now most noon, and have seen a rather elderly lady go out and
in the house a number of times. The intrepid Dave is going up to
the house to interview the lady soon. <span class="smcap">Later.</span>—Dave crawled along
from our hiding place until he came to the open ground, and then<span class="x-ebookmaker-pageno" title="[146]"><a id="Page_146"></a></span>
straightened boldly up and walked to the house. In fifteen minutes
he came back with some bread and dried beef, and said the woman
was a Union woman and would help us. Her daughter slept at her
uncle’s a mile off last night, and expected her back soon, and perhaps
the uncle, who is a violent Secesh, with her. Said for us to
lay low. <span class="smcap">Later.</span>—The daughter came home on horseback and
alone. Could see the old lady telling the daughter about us and
pointing our way. About the middle of the afternoon the old lady
started out toward us. Behind her came a young darky, and behind
the darky came another darky; then a dog, then a white boy, then a
darky, and then the daughter. Old lady peeked in, and so did the
rest except the grown-up girl, who was too afraid. Finally came
closer, and as she got a good view of us she says: “Why, mother,
they look just like anybody else.” She had never seen a Yankee
before. Brought us some more food, and after dark will set a table
for us to come to the house and eat. Her name is Mrs. Dickinson.
They went back to the house and we proceeded to shake hands with
one another. During the afternoon five rebel soldiers came to the
house, one at a time. It is now most dark and we are about ready
to go to the house and eat. Mr. Kimball lives only four miles away.</p>
<p class="calibre3">Dec. 19.—We are now less than half a mile from Mr. Kimball’s.
After dark last night we went to Mrs. Dickinson’s house and partook
of a splendid supper. I wrote a paper directed to the officer commanding
the first Yankee troops that should arrive here telling what
she had done for us runaway Yankees. She talked a great deal, and
I thought was careless leaving the front door open. Three or four
times I got up and shut that door. We had taken off our blankets
and other wraps and left them in a sort of a kitchen, and were talking
in the best room. I heard the gate click, and on looking out
saw two rebel officers coming to the house and not six rods off. We
jumped into the other room and out of the back door and behind a
corn house, bare headed. The officers were asked into the front
room by the daughter. They asked who the parties were who ran
out of the back way. She said she reckoned no one. They kept at
her and jokingly intimated that some of her skulking lovers had
been to see her. She kept talking back and finally said: “Mother,
did any one just go away?” And the old lady said: “Why, yes,
brother Sam and his ‘boy’ just went off home.” Them confounded
rebels had come to see the girl and spend the evening, and we shivering
out in the cold. Joked her for an hour and a half about her<span class="x-ebookmaker-pageno" id="pgepubid00122" title="[147]"><a id="Page_147"></a></span>
lovers and we hearing every word. Finally they got up and bid her
good night, saying they would send back some men to guard the
house and keep her lovers away. Just as soon as they were down
the road a ways, the daughter came out very frightened and said for
us to hurry off, as they would send back troops to look for us. Hurried
into the house, got our things and some dried beef, and started
off toward Mr. Kimball’s house. Reached here just before daylight
and lay down back of the house about eighty rods, in the corner of
the fence, to sleep a little before morning. Just at break of day heard
some one calling hogs. David got up and went toward an old man
whom we knew was our friend Kimball. Came to us, and was glad
to shake hands with genuine Yankees. Said one of his neighbors
was coming over early to go with him to hunt some hogs, and for us
to go farther off and stay until night, and he would think up during
the day what to do with us. Did not want anything to eat. Came
to this place where we now are, and feeling that our journey was
most ended. Mr. Kimball said that Sherman was not over fifty
miles off, and coming right along twenty miles per day, and our plan
was to hide and await coming events. Mr. Kimball is an old man,
probably sixty years old, white haired and stoop shouldered. He
had five sons, all drafted into the rebel army. All refused to serve.
Two have been shot by the rebels, one is in some prison for his Union
proclivities, and two are refugees. The old man has been imprisoned
time and again, his stock confiscated, property destroyed, and all
together had a hard time of it. Still he is true blue, a Union man to
the back bone. Really think our troubles coming to an end. Kimball
said: “Glory to God, the old Stars and Stripes shall float over
my house in less than a week!” It’s a noble man who will stand out
through all that he has, for his principles, when his interests are all
here. Is not only willing, but glad to help us, and says anything he
has is ours, if it will help us toward our escape. <span class="smcap">Later.</span>—Have
been laying all day watching Kimball’s house. Along in the morning
the neighbor spoken of came to Kimball’s, and they both went off
on horseback to shoot hogs. The swine here roam over a large territory
and become most wild, and when they want fresh pork they
have to go after it with a gun. You may be sure the hunters did not
come near us with Mr. Kimball for a guide. A negro boy went with
them with a light wagon and mule attached. Near noon they returned
with some killed hogs in the wagon. At three or four o’clock
the old man came down where we were “to look after his boys,” he
said. Is in the best of spirits. Says we are to hide to-night where<span class="x-ebookmaker-pageno" title="[148]"><a id="Page_148"></a></span>
he tells us, and stay until our troops reach us. That is jolly good
news for me, as I hate to travel. Said come to the house after dark
and he would have a supper prepared for us, and has just left us.
<span class="smcap">Later.</span>—Have just eaten a splendid supper at Kimball’s and getting
ready to travel three miles to a safe hiding place.</p>
<p class="calibre3">Dec. 20.—Well, we are just well fixed and happy. After partaking
of a royal repast last night, served in an out-building near the
main building of the Kimball home, we were directed to this place
which is on the banks of the Big Ogechee river, in a most delightful
spot. While we were at Kimball’s he had negro sentinels stationed
at different points on the plantation to announce the coming of any
rebel soldiers or citizens that might see fit to come near. He gave us
an axe, a quart of salt, a ham too big to carry conveniently, and all
the sweet potatoes we could drag along; also a butcher knife. Went
with us a mile as guide and then told us so we found the place pointed
out. Also gave us some shelled corn to bait hogs and told Dave
how to make a deadfall to catch them. We left the main road going
directly West until we came to a fence, then turned to the left and
followed the line of the fence, and when we had got to the end of it
kept straight ahead going through a swampy low section. After a
while came to higher and dry land and to the banks of the river. Is
a sort of an island, and as I said before, a very pretty and pleasant
spot. Out in the river grows tall canebrake which effectually
hides us from any one going either up or down the river. Tall pines
are here in abundance and nice grass plats, with as handsome palm
clusters as ever I saw. Are going to build us a house to keep off the
cold and rain. Have matches and a rousing fire cooked our breakfast
of nice ham and sweet potatoes. We also roasted some corn and
had corn coffee. Any quantity of hogs running around and Dave is
already thinking of a trap to catch them. It will be necessary for
we are making that ham look sick. Eat so much breakfast that we
can hardly walk and don’t know but will commit suicide by eating.
Buzzards fly around attracted by the cooking. Are as large and look
like turkeys. Our government should give to Mr. Kimball a fortune
for his patriotism and sacrifices to the Union cause. About eight
miles above is a long bridge across the river and there it is thought
a big fight will take place when Sherman attempts to cross, and so we
will know when they approach, as we could hear a battle that distance.
<span class="smcap">Night.</span>—We have built the cosyest and nicest little house to
lay in. Cut poles with the axe and made a frame, and then covered
the top with palm leaves just like shingles on a house at the North,<span class="x-ebookmaker-pageno" title="[149]"><a id="Page_149"></a></span>
then fixed three sides the same way, each leaf overlapping the other,
and the fourth side open to a fire and the river. The water is cold
and clear and nice to drink; just like spring water. Have eaten the
ham half up; ditto potatoes. The increased prosperity makes me
feel well bodily, and mentally am more so. It is still the “Astor
House Mess.” We all cook, and we all eat. Dave prays to-night as
he does every night and morning, and I ain’t sure but all through
the day. Is a thorough Christian if ever there was one. I also wrote
a letter for Mr. Kimball to the commanding Union officer who may
first approach these parts. In it I told how he had befriended us
and others. We heard boats going by on the river to-day. At such
times all we do is to keep still, as no one can see us. Rebels are too
busy to look for us or any one else. All they can do now to take
care of themselves. Eli is making up our bed, getting ready to turn
in. I have just brought a tin pail of nice water and we all drink.
Take off our shoes for the first time in some days. A beautiful night—clear
and cold. And thus ends another day, and we are in safety.</p>
<p class="calibre3">Dec. 21.—Got up bright and early. Never slept better. Getting
rested up. We talk continually. Both Bucks are great talkers,
especially David. Cooked and ate our breakfast, and would you
believe it the ham is all gone. Incredible, the amount of food we
eat. Wonder it don’t make us all sick. Sweet potatoes getting low.
Dave fixing up his deadfall for hogs. Has rolled some heavy logs
together forty rods away from our house, and fixed up a figure four
spring trap, with the logs for weight to hold down the animal which
may be enticed into it. Has scattered corn in and around the trap,
and we wait for developments. Hogs are very shy of us and surroundings.
Are apparently fat and in good order. Plenty of roots
and shack which they eat, and thrive thereon. Buzzards are very
curious in regard to us. They light on the limbs in the trees, and if
their support is a dead limb it breaks and makes a great noise in the
still woods. Two or three hundred all together make a terrible
racket, and scare us sometimes. The weather is very fine, and this
must be a healthy climate. Dave is going out to-day to look around.
As I have said before, he is a scout and understands spying around,
and won’t get caught. If we had a fish hook and line or a net of
some sort could catch fish to eat. That would be a grand sport
as we can see nice large fish in the water. The main road is away
about one and a half miles we think by the sound of the teams which
occasionally rumble along. Often hear shouting on the road as if cattle<span class="x-ebookmaker-pageno" id="pgepubid00123" title="[150]"><a id="Page_150"></a></span>
were being driven along toward Savannah. Once in a while we
hear guns fired off, but it is no doubt hogs being killed. We also
hear folks going up and down the river, but cannot see them. After
dark we have no fire as that would expose us, it is so much plainer
to be seen in the night. The river is wide; should think a third of
a mile, as we can view it from away up the stream. The cane
that grows in the river is the same as we have for fish poles at the
North, and are shipped from the South. Have added some repairs
to the house and it is now water tight, we think. Made a bed of
soft boughs, and with our three blankets have a good sleeping place.
Dave got a tall cane and fastened up on the house, and for a flag
fastened on a piece of black cloth—the best we could do. That
means no quarter; and it is just about what we mean, too. Don’t
believe we would be taken very easy now. I am getting fat every
day, yet lame, and have come to the conclusion that it will be a long
time before I get over it. The cords have contracted so in my right
leg that they don’t seem to stretch out again to their original length.
That scurvy business came very near killing me. <span class="smcap">Later.</span>—I also
went out of our hiding place, and saw away out in a field what I
took to be a mound where sweet potatoes were buried. Came back
and got a pair of drawers, tied the bottom of the legs together, and
sallied forth. The mound of potatoes was a good way back from
the house, although in plain sight. I crawled up, and began digging
into it with a piece of canteen. Very soon had a hole in, and found
some of the nicest potatoes that you can imagine, of the red variety,
which I believe are the genuine Southern yam. Filled the drawers
cram full, filled my pockets and got all I could possibly carry, then
closed up the hole and worked my way back to camp. Eli was
alone, Dave not having returned from his scouting trip. Had a war
dance around those potatoes. Believe there is a bushel of them, and
like to have killed myself getting them here. After I got into the
woods and out of the field, straightened up and got the drawers
on my shoulders and picked the way to head-quarters. We don’t
any of us call any such thing as that stealing. It’s one of the necessities
of our lives that we should have food, and if we have not
got it, must do the best we can. Now if we can catch a porker will
be fixed all right for some days to come. Think it is about the time
of year for butchering. We don’t expect to be here more than two
or three days at fartherest, although I shall hate to leave this beautiful
spot, our nice house and all. Listen all the time for the expected
battle at the bridge, and at any unusual sound of commotion in<span class="x-ebookmaker-pageno" title="[151]"><a id="Page_151"></a></span>
that direction we are all excitement. <span class="smcap">Later.</span>—Dave has returned.
He went to the main road and saw a negro. Was lucky enough to
get a Savannah paper three days old in which there was nothing we
did not know in regard to Sherman’s coming. The negro said yankee
scouts had been seen just across the river near the bridge, and
the main army is expected every day. The rebels will fall back
across the river and contest the crossing. Fortifications are built all
along clear to Savannah, and it may be reasonably expected that
some hard fighting will take place. Savannah is the pride of the
South and they will not easily give it up. Dave did not tell the negro
that he was a yankee, but represented himself as a conscript hiding
in the woods to keep from fighting in the rebel army. Was glad
to see supply of potatoes and says I will do. Has freshly baited his
trap for hogs and thinks before night we will have fresh pork to go
with the potatoes. <span class="smcap">Later.</span>—We went around a drove of hogs and
gradually and carefully worked them up to the trap. Pretty soon
they began to pick up the corn and one of them went under the figure
four, sprung it and down came the logs and such a squealing and
scrambling of those not caught. The axe had been left near the trap
standing up against a tree, and Dave ran up and grabbed it and
struck the animal on the head and cut his throat. How we did
laugh and dance around that defunct porker. Exciting sport this
trapping for fresh pork. In half an hour Dave and Eli had the pig
skinned and dressed. Is not a large one probably weighs ninety
pounds or so, and is fat and nice. Have sliced up enough for about
a dozen men and are now cooking it on sticks held up before the fire.
Also frying some in a skillet which we are the possessor of. When
the hogs run wild and eat acorns, roots and the like, the meat is
tough and curly but is sweet and good. We fry out the grease and
then slice up the potatoes and cook in it. Thanks to Mr. Kimball
we have plenty of salt to season our meat with. The buzzards are
after their share which will be small. And now it is most night
again and the “Astor House” larder is full. Seems too bad to go
to bed with anything to eat on hand, but must. That is the feeling
with men who have been starved so long, cannot rest in peace with
food laying around. My two comrades are not so bad about that as
I am, having been well fed for a longer period. Have sat up three
or four hours after dark, talking over what we will do when we get
home, and will now turn in for a sound sleep. It’s a clear moonlight
night, and we can hear very plain a long distance. Can also<span class="x-ebookmaker-pageno" title="[152]"><a id="Page_152"></a></span>
see the light shining from camp fires in many directions, or what we
take to be such.</p>
<p class="calibre3">Dec. 22.—As Dan Rice used to say in the circus ring: “Here we
are again.” Sleep so sound that all the battles in America could not
wake me up. Are just going for that fresh pork to-day. Have three
kinds of meat—fried pig, roast pork and broiled hog. Good any
way you can fix it. Won’t last us three days at this rate, and if we
stay long enough will eat up all the hogs in these woods. Pretty
hoggish on our part, and Dave says for gracious sake not to write
down how much we eat, but as this diary is to be a record of what
takes place, down it goes how much we eat. Tell him that inasmuch
as we have a preacher along with us, we ought to have a sermon
occasionally. Says he will preach if I will sing, and I
agree to that if Eli will take up a collection. One objection Eli and
I have to his prayers is the fact that he wants the rebels saved with
the rest, yet don’t tell him so. Mutually agree that his prayers are
that much too long. Asked him if he thought it stealing to get those
potatoes as I did, and he says no, and that he will go next time. We
begin to expect the Yankees along. It’s about time. Don’t know
what I shall do when I again see Union soldiers with guns in their
hands, and behold the Stars and Stripes. Probably go crazy, or
daft, or something. This is a cloudy, chilly day, and we putter
around gathering up pine knots for the fire, wash our duds and otherwise
busy ourselves. Have saved the hog skin to make moccasins
of, if the Union army is whipped and we have to stay here eight or
ten years. The hair on our heads is getting long again, and we begin
to look like wild men of the woods. One pocket comb does for
the entire party; two jack knives and a butcher knife. I have four
keys jingling away in my pocket to remind me of olden times. Eli
has a testament and Dave has a bible, and the writer hereof has not.
Still, I get scripture quoted at all hours, which will, perhaps, make
up in a measure. Am at liberty to use either one of their books, and
I do read more or less. Considerable travel on the highways, and
going both ways as near as we can judge. Dave wants to go out to
the road again but we discourage him in it, and he gives it up for to-day
at least. Are afraid he will get caught, and then our main stay
will be gone. Pitch pine knots make a great smoke which rises
among the trees and we are a little afraid of the consequences; still,
rebels have plenty to do now without looking us up. Many boats go
up and down the river and can hear them talk perhaps fifty rods<span class="x-ebookmaker-pageno" id="pgepubid00124" title="[153]"><a id="Page_153"></a></span>
away. Rebel paper that Dave got spoke of Savannah being the point
aimed at by Sherman, also of his repulses; still I notice that he keeps
coming right along. Also quoted part of a speech by Jefferson
Davis, and he is criticised unmercifully. Says nothing about any
exchange of prisoners, and our old comrades are no doubt languishing
in some prison. <span class="smcap">Later.</span>—Considerable firing up in vicinity of
the bridge. Can hear volleys of musketry, and an occasional boom
of cannon. Hurrah! It is now four o’clock by the sun and the battle
is certainly taking place. <span class="smcap">Later.</span>—Go it Billy Sherman, we are
listening and wishing you the best of success. Come right along and
we will be with you. Give ’em another—that was a good one. We
couldn’t be more excited if we were right in the midst of it. Hurrah!
It is now warm for the Johnnies. If we had guns would go
out and fight in their rear; surround them, as it were. Troops
going by to the front, and are cavalry, should think, also artillery.
Can hear teamsters swearing away as they always do. <span class="smcap">Later.</span>—It is
now long after dark and we have a good fire. Fighting has partially
subsided up the river, but of course we don’t know whether Yankee
troops have crossed the river or not. Great deal of travel on the
road, but can hardly tell which way they are going. Occasional firing.
No sleep for us to-night. In the morning shall go out to the
road and see how things look. Every little while when the battle
raged the loudest, all of us three would hurrah as if mad, but we
ain’t mad a bit; are tickled most to death.</p>
<div class="calibre illowe10 figure" id="i_sep3a">
<img alt="separator; small circular coastal scene" class="calibre6" id="id-3568529713083005190" src="Images/img0013.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0016.vue?52226cbb